// src/aws-config.ts
import { Amplify, type ResourcesConfig } from 'aws-amplify';

export const amplifyConfig: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolId: import.meta.env['VITE_ADMIN_COGNITO_USER_POOL_ID'],
      userPoolClientId: import.meta.env['VITE_ADMIN_COGNITO_CLIENT_ID'],
    },
  },
};

Amplify.configure(amplifyConfig);
